"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AnalyticsProvider_1 = require("./AnalyticsProvider");

var GenericProvider =
/** @class */
function (_super) {
  __extends(GenericProvider, _super);

  function GenericProvider() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  GenericProvider.prototype.initialClick = function (dealId, vehicle) {
    console.log("initial click", dealId, vehicle);
  };

  GenericProvider.prototype.tradeInStart = function (dealId, vehicle) {
    console.log("Trade in start.", dealId, vehicle);
  };

  GenericProvider.prototype.tradeInEstimate = function (dealId, vehicle) {
    console.log("Trade in estimate.", dealId, vehicle);
  };

  GenericProvider.prototype.tradeInComplete = function (dealId, vehicle) {
    console.log("Trade in complete.", dealId, vehicle);
  };

  GenericProvider.prototype.calculationStart = function (dealId, vehicle) {
    console.log("Begin calculate payment.", dealId, vehicle);
  };

  GenericProvider.prototype.calculationFinish = function (dealId, vehicle) {
    console.log("Finish calculate payment.", dealId, vehicle);
  };

  GenericProvider.prototype.leadFormStart = function (dealId, vehicle) {
    console.log("Start form lead", dealId, vehicle);
  };

  GenericProvider.prototype.leadFormFinish = function (dealId, vehicle) {
    console.log("Finish form lead", dealId, vehicle);
  };

  GenericProvider.prototype.appointmentScheduled = function (dealId, vehicle) {
    console.log("Scheduled appointment", dealId, vehicle);
  };

  GenericProvider.prototype.creditAppComplete = function (dealId, vehicle) {
    console.log("creditAppComplete", dealId, vehicle);
  };

  GenericProvider.prototype.softPullCreditAppStart = function (dealId, vehicle) {
    console.log("softPullCreditAppStart", dealId, vehicle);
  };

  GenericProvider.prototype.softPullCreditAppComplete = function (dealId, vehicle) {
    console.log("softPullCreditAppComplete", dealId, vehicle);
  };

  GenericProvider.prototype.hardPullCreditAppStart = function (dealId, vehicle) {
    console.log("hardPullCreditAppStart", dealId, vehicle);
  };

  GenericProvider.prototype.hardPullCreditAppComplete = function (dealId, vehicle) {
    console.log("hardPullCreditAppComplete", dealId, vehicle);
  };

  GenericProvider.prototype.FAndIFinish = function (dealId, vehicle) {
    console.log("Finish F&I", dealId, vehicle);
  };

  GenericProvider.prototype.dropSave = function (dealId, vehicle) {
    console.log("Drop save", dealId, vehicle);
  };

  GenericProvider.prototype.buildNewPayment = function () {
    console.log("buildNewPayment");
  };

  GenericProvider.prototype.signInToGarageGarageIcon = function () {
    console.log("signInToGarageGarageIcon");
  };

  GenericProvider.prototype.savesPayment = function () {
    console.log("savesPayment");
  };

  GenericProvider.prototype.skipCreditApp = function () {
    console.log("skipCreditApp");
  };

  GenericProvider.prototype.creditAppPrimaryPageTwo = function () {
    console.log("creditAppPrimaryPageTwo");
  };

  GenericProvider.prototype.cosignerYes = function () {
    console.log("cosignerYes");
  };

  GenericProvider.prototype.exploreUpgrades = function () {
    console.log("exploreUpgrades");
  };

  GenericProvider.prototype.skipUpgrades = function () {
    console.log("skipUpgrades");
  };

  GenericProvider.prototype.continueDeal = function (vin) {
    console.log("continueDeal");
  };

  GenericProvider.prototype.addUpgrade = function (id) {
    console.log("addUpgrade");
  };

  GenericProvider.prototype.pickDeliveryDate = function (date) {
    console.log("pickDeliveryDate");
  };

  GenericProvider.prototype.pickDeliveryTime = function (time) {
    console.log("pickDeliveryTime");
  };

  GenericProvider.prototype.reserveVehicleFormStart = function (dealId, vehicle) {
    console.log("Reserve Vehicle form start", dealId, vehicle);
  };

  GenericProvider.prototype.reserveVehicleFormFinish = function (dealId, vehicle) {
    console.log("Reserve Vehicle form finish", dealId, vehicle);
  };

  GenericProvider.prototype.virtualPageView = function (pagePath) {
    console.log("virtualPageView", pagePath);
  };

  GenericProvider.prototype.paymentBuilderLoad = function (dealId, vehicle) {
    console.log("Payment builder load", dealId, vehicle);
  };

  GenericProvider.prototype.paymentOptionsLoad = function (dealId, vehicle) {
    console.log("Payment Options load", dealId, vehicle);
  };

  return GenericProvider;
}(AnalyticsProvider_1.AnalyticsProvider);

exports.default = GenericProvider;